import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { HeaderBannerDto } from '../models/dto/header-banner-dto';

export class HeaderBannerApi {
    constructor(protected baseUrl: string) {}

    public getActiveHeaderBanners = (): Promise<ApiResult<PaginatedResponse<HeaderBannerDto>>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/header-banners`),
            response => response.data
        );
    };
}
